{
  "cms.schedule.title": "Scheduled publishing",
  "cms.schedule.description": "Choose a start and/or end time — the content publishes and unpublishes automatically at the chosen times.",
  "cms.schedule.windowLabel": "Publishes",
  "cms.schedule.endWindowLabel": "Unpublishes",
  "cms.schedule.datePlaceholder": "Pick a date",
  "cms.schedule.clear": "Clear",
  "cms.schedule.submit": "Schedule",
  "cms.schedule.reschedule": "Reschedule",
  "cms.schedule.cancel": "Cancel schedule",
  "cms.schedule.pending": "Scheduled to publish:",
  "cms.schedule.endPending": "Scheduled to unpublish:",
  "cms.schedule.locked": "This schedule is saved. You can change it in the page editor.",
  "cms.schedule.error.past": "The scheduled time is in the past. Pick a future time.",
  "cms.schedule.error.exists": "This content already has a schedule. Reschedule or cancel it first.",
  "cms.schedule.error.noPending": "No schedule found.",
  "cms.schedule.error.windowInverted": "The unpublish time must be after the publish time.",
  "cms.schedule.error.generic": "Scheduling failed. Please try again.",
  "cms.schedule.error.load": "Could not load schedules. Please try again.",
  "cms.schedule.error.afterContentSave": "The content was saved, but the schedule could not be saved. Correct it and save again.",
  "cms.schedule.calendar.month.1": "January",
  "cms.schedule.calendar.month.2": "February",
  "cms.schedule.calendar.month.3": "March",
  "cms.schedule.calendar.month.4": "April",
  "cms.schedule.calendar.month.5": "May",
  "cms.schedule.calendar.month.6": "June",
  "cms.schedule.calendar.month.7": "July",
  "cms.schedule.calendar.month.8": "August",
  "cms.schedule.calendar.month.9": "September",
  "cms.schedule.calendar.month.10": "October",
  "cms.schedule.calendar.month.11": "November",
  "cms.schedule.calendar.month.12": "December",
  "cms.schedule.calendar.weekdays": "Mo Tu We Th Fr Sa Su",
  "cms.schedule.calendar.previousMonth": "Previous month",
  "cms.schedule.calendar.nextMonth": "Next month"
}
